<template>
  <div class="invite-container">
    <div class="wrapper">
      <div class="step-wrapper">
        <div
          class="step-item"
          :class="{ 'step-item-active': curStep == index }"
          v-for="(item, index) in stepList"
          :key="index"
        >
          <div class="item-step">步骤{{ index + 1 }}</div>
          <div class="item-text">{{ item.title }}</div>
        </div>
        <div class="step-line"></div>
      </div>
      <div class="register-wrapper" v-show="curStep == 0">
        <div class="input-item">
          <div class="area-code item-left">+86</div>
          <input
            class="input"
            type="number"
            placeholder="请输入手机号码"
            maxlength="20"
            v-model="phone"
            @blur="checkPhone(phone)"
          />
        </div>
        <div class="input-item">
          <div class="item-left block iconfont icon-weijiesuo"></div>
          <input
            class="input"
            type="number"
            placeholder="输入验证码"
            @blur="checkCode(code)"
            maxlength="4"
            v-model="code"
          />
          <div class="send-code" @click="bindSendCode">
            {{ codeTime ? codeTime + 'S' : '获取验证码' }}
          </div>
        </div>
        <div class="register-btn" @click="bindLogin">注册</div>
        <div class="agrement">
          <div class="check" @click="bindToggleAgree"
            ><span class="iconfont icon-gou" v-show="agree"></span
          ></div>
          <div class="agrement-text"
            >我已阅读并同意<span class="agrement-bold" @click="bindToAgreement"
              >《用户隐私协议》《用户服务协议》</span
            ></div
          >
        </div>
      </div>
      <div class="download-wrapper" v-show="curStep == 1">
        <div class="logo-container">
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
            alt=""
          />
          <div>
            <div class="app-name">betterWE星球</div>
            <div class="app-desc">真人营养师服务平台</div>
          </div>
        </div>
        <div class="download-btn" @click="bindDownload">点击下载app</div>
      </div>
    </div>
  </div>
</template>
<script>
import BetterweWxApi from '@/components/wx/control.js'
export default {
  data() {
    return {
      curStep: 0,
      stepList: [
        {
          title: '手机号码注册'
        },
        {
          title: '下载betterWE星球'
        }
      ],
      disabledSend: false, //是否禁用发送验证码
      codeTime: 0, //验证码等待时间
      timer: null,
      username: '',
      phone: '',
      code: '',
      agree: false
    }
  },
  computed: {
    disabledLogin() {
      let disabledLogin = !this.phone || !this.code
      return disabledLogin
    },
    activityId() {
      return this.$route?.query?.aid || 1
    }
  },
  watch: {
    code(val) {
      if (val.length > 4) {
        this.code = val.slice(0, 4)
      }
    }
  },
  created() {
    this.setShareData()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    setShareData() {
      let shareData = {
        link: location.href,
        desc: '点击领取真人营养师服务>>>',
        title: '据说有人跟营养师吃瘦了10斤！',
        imgUrl:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png' // 分享的缩略图的url
      }
      BetterweWxApi.setShareData(shareData, shareData)
    },
    bindStop() {},
    bindToggleAgree() {
      this.agree = !this.agree
    },
    bindToAgreement() {
      this.$router.push('/privacy-agreement')
    },
    bindClose() {
      this.$emit('close')
    },
    bindSendCode() {
      if (this.disabledSend) {
        return
      }
      if (!this.checkPhone(this.phone)) {
        this.$toast('请检查手机号码长度')
        return
      }
      if (!this.agree) {
        this.$toast('请勾选隐私协议')
        return
      }
      this.disabledSend = true
      let params = {
        phone: this.phone,
        areaCode: '86'
      }
      this.$http
        .postBaseApp('sendSms', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$toast('发送成功')
            this.codeInterval()
          } else {
            this.disabledSend = false
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.disabledSend = false
        })
    },
    codeInterval() {
      this.codeTime = 60
      this.timer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          this.disabledSend = false
          clearInterval(this.timer)
          // this.codeTime = 0;
        }
      }, 1000)
    },
    checkParams() {
      let res = this.checkPhone(this.phone) && this.checkCode(this.code)
      return res
    },
    checkPhone(phone) {
      if (!phone.length) {
        this.$toast('请输入电话号码')
        return false
      }
      if (phone.length != 11) {
        this.$toast('请检查手机号码长度')
        return false
      }
      return true
    },
    checkCode(code) {
      code = code.trim()
      if (!code) {
        this.$toast('请输入验证码')
      }
      return code
    },
    async bindLogin() {
      if (!this.agree) {
        this.$toast('请勾选隐私协议')
        return
      }
      if (!this.checkParams()) {
        return
      }
      let params = {
        phone: this.phone,
        inviter_uid: this.$route.query.uid,
        code: this.code,
        activity_id: this.activityId
      }
      let res = await this.$http
        .getApp('api/v1/Vote/inviteUserRegister', params)
        .catch((err) => {
          console.log(err)
        })
      if (res) {
        res = res.data
        if (res.code === 200) {
          this.$toast('注册成功')
          this.curStep = 1
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.msg
          })
        }
      }
    },
    bindDownload() {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-container {
  min-height: 100vh;
  overflow: hidden;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/edd17c1f7e34493a9e66f6a3a7573cec.png');
  background-position: center top;
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: rgb(231, 228, 255);

  .wrapper {
    width: 343px;
    margin: 355px auto 42px;
    background: #f7f7f7;
    border-radius: 12px;
    overflow: hidden;

    .step-wrapper {
      background: #ffffff;
      padding: 14px 0 10px;
      display: flex;
      align-items: center;
      position: relative;
      overflow: hidden;

      .step-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item-step {
          text-align: center;
          width: 70px;
          height: 19px;
          background: #cccccc;
          border-radius: 10px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 5px;
        }

        .item-text {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.3);
          line-height: 20px;
        }
      }

      .step-item-active {
        .item-step {
          background: #6236ff;
        }

        .item-text {
          color: rgba(0, 0, 0, 0.8);
        }
      }

      .step-line {
        position: absolute;
        left: 50%;
        width: 0;
        height: 0;
        top: 50%;
      }

      .step-line::before {
        position: absolute;
        content: '';
        width: 1px;
        height: 40px;
        background: #d9d9d9;
        transform: rotate(-205deg);
        transform-origin: center top;
      }

      .step-line::after {
        position: absolute;
        content: '';
        width: 1px;
        height: 40px;
        background: #d9d9d9;
        transform: rotate(25deg);
        transform-origin: center top;
      }
    }

    .register-wrapper {
      padding: 30px 18px 50px;

      .input-item {
        display: flex;
        align-items: center;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #f1f1f1;
        padding: 10px 23px;
        margin-bottom: 10px;

        .area-code {
          color: #7e7e7e;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
        }

        .block {
          color: rgba(0, 0, 0, 0.3);
        }

        .item-left {
          flex: 0 0 66px;
          width: 66px;
        }

        .input {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          border: none;
          outline: none;
          background: transparent;
          height: 20px;
        }

        .input::placeholder {
          color: rgba(0, 0, 0, 0.3);
          line-height: 20px;
        }

        .send-code {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #6236ff;
          line-height: 20px;
          white-space: nowrap;
          margin-left: 10px;
        }
      }

      .register-btn {
        height: 40px;
        background: #6236ff;
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        letter-spacing: 3px;
        line-height: 40px;
        text-align: center;
        margin-top: 16px;
        margin-bottom: 15px;
      }

      .agrement {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .check {
          width: 20px;
          height: 20px;
          border-radius: 4px;
          border: 1px solid rgba(221, 221, 221, 1);
          box-sizing: border-box;
          margin-right: 9px;
          display: flex;
          align-items: center;
          justify-content: center;

          .iconfont {
            font-weight: 600;
            font-size: 16px;
            color: rgba(98, 54, 255, 1);
          }
        }

        .agrement-text {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: #878787;
          line-height: 16px;

          .agrement-bold {
            color: rgba(0, 0, 0, 0.8);
            font-weight: 600;
          }
        }
      }
    }

    .download-wrapper {
      height: 260px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .logo-container {
        display: flex;
        align-items: center;
        margin-bottom: 46px;

        .logo {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }

        .app-name {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 22px;
        }

        .app-desc {
          font-size: 10px;
          font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
          color: rgba(0, 0, 0, 0.8);
          line-height: 14px;
          letter-spacing: 1px;
        }
      }

      .download-btn {
        width: 305px;
        text-align: center;
        height: 40px;
        background: #6236ff;
        border-radius: 10px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 40px;
        letter-spacing: 3px;
      }
    }
  }
}
</style>
